export const btn = {
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    border: "none",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "0.88rem",
    cursor: "pointer",
    padding: "9px 18px",
    transition: "opacity 0.15s, box-shadow 0.15s",
    lineHeight: 1,
  },
  primary: {
    background: "#1a73e8",
    color: "#fff",
    boxShadow: "0 2px 8px rgba(26,115,232,0.25)",
  },
  success: {
    background: "#2e7d32",
    color: "#fff",
    boxShadow: "0 2px 8px rgba(46,125,50,0.25)",
  },
  danger: {
    background: "#c62828",
    color: "#fff",
    boxShadow: "0 2px 8px rgba(198,40,40,0.25)",
  },
  secondary: {
    background: "#f5f5f5",
    color: "#424242",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  },
  icon: {
    width: "32px",
    height: "32px",
    padding: 0,
    borderRadius: "8px",
    fontSize: "0.82rem",
  },
  iconSoft: (bg, color) => ({ background: bg, color }),
};

export const btnHoverStyle = `
  .btn-modern { transition: opacity 0.15s, transform 0.1s; }
  .btn-modern:hover { opacity: 0.88; transform: translateY(-1px); }
  .btn-modern:active { opacity: 1; transform: translateY(0); }
`;
